var isCashAppPay = function (method) { return Boolean(method) && typeof method === 'object' && 'cashtag' in method && 'id' in method; };

export { isCashAppPay };
